import Commodities from './commodities';
import Dimensions from './dimensions';
import UnitsOfMeasurement from './units-of-measurement';
import Zones from './zones';
import LoadZones from './load-zones';
import BillingTypes from './billing-types';
import WeatherZones from './weather-zones';
import UtilityBillingTypes from './utility-billing-types';
import StateCommodities from './state-commodities';
import LicenseTypes from './license-types';
import StateLicenseRequirements from './state-license-requirements';
import CompanyAlias from '../../dataManagement/companyAlias';
import Utilities from '../../utilities';
import RateClass from '../../rateClass';
import Brand from '../../dataManagement/brand';

// Route metadata only; each tab owns its columns and API integration.
export const lookupTables = [
    { id: 'billing-types', title: 'Billing Types', singularTitle: 'Billing Type', Component: BillingTypes },
    { id: 'brand', title: 'Brand', singularTitle: 'Brand', Component: Brand },
    { id: 'commodities', title: 'Commodities', singularTitle: 'Commodity', Component: Commodities },
    { id: 'company-alias', title: 'Company Alias', singularTitle: 'Company Alias', Component: CompanyAlias },
    { id: 'dimensions', title: 'Dimensions', singularTitle: 'Dimension', Component: Dimensions },
    { id: 'license-types', title: 'License Types', singularTitle: 'License Type', Component: LicenseTypes },
    { id: 'zones', title: 'Load Profiles', singularTitle: 'Load Profile', Component: Zones },
    { id: 'load-zones', title: 'Load Zones', singularTitle: 'Load Zone', Component: LoadZones },
    { id: 'rate-classes', title: 'Rate Classes', singularTitle: 'Rate Class', Component: RateClass },
    { id: 'state-commodities', title: 'State Commodities', singularTitle: 'State Commodity', Component: StateCommodities },
    { id: 'state-license-requirements', title: 'State Licenses', singularTitle: 'State License', Component: StateLicenseRequirements },
    { id: 'units-of-measurement', title: 'Units of Measurements', singularTitle: 'Unit of Measurement', Component: UnitsOfMeasurement },
    { id: 'utilities', title: 'Utilities', singularTitle: 'Utility', Component: Utilities },
    { id: 'utility-billing-types', title: 'Utility Billing Types', singularTitle: 'Utility Billing Type', Component: UtilityBillingTypes },
    { id: 'weather-zones', title: 'Weather Zones', singularTitle: 'Weather Zone', Component: WeatherZones },
];
